import VueRouter from "vue-router";
import { setDocumentTitle } from "@utils/domUtil";
import { createProgressEndGuard } from "./NProgressGuard";
// import store from "@/store/index";
export function onChangeRouterSuccess(router: VueRouter): void {
  router.afterEach(async (to) => {
    // if (to.name) {
    //   store.commit("SET_CurrentRouteName", to.name);
    // }
    setDocumentTitle((to as any).meta.title);
    return true;
  });
  createProgressEndGuard(router);
}
